module.exports = __webpack_public_path__ + "img/DISCORD_CERTIFIED_MODERATOR.9a93af9d.svg";